import { defineComponent as _defineComponent } from 'vue'
import CheckSolidIcon from '@/assets/img/CheckSolidIcon.svg'
import XSolidIcon from '@/assets/img/XSolidIcon.svg'
import { computed, useContext } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationFooterSaveButtons',
  setup(__props) {

const ctx = useContext()

const saveButtonListeners = computed(() => {
  if (ctx.$notif.savingState?.onSave) {
    return {
      click: ctx.$notif.savingState.onSave,
    }
  }
})

return { __sfc: true,ctx, saveButtonListeners, CheckSolidIcon, XSolidIcon }
}

})